<template>
  <base-modal
    id="viewTemplateModal"
    size="lg"
    type="fullheight"
    modalBodyClass="overflow-hidden p-2"
    :toggle="true"
  >
    <iframe
      title="static mail template"
      class="template-frame"
      :srcdoc="templateHtml"
      width="100%"
    ></iframe>
  </base-modal>
</template>

<script>
import baseModal from "@/modules/Common/_components/base-modal.vue";
export default {
  components: {
    baseModal,
  },
  props: {
    templateHtml: String,
  },
};
</script>

<style scoped>
.template-frame {
  height: 100%;
  overflow: hidden;
  border: 1px solid #dee2e6;
  box-shadow: border-box;
  border-radius: 5px;
  width: 100%;
}
</style>
